module.exports = __webpack_public_path__ + "img/LOGOI.407e0218.png";